export const getLocalStorageItem = (key, defaultValue = '') => {
    const item = localStorage.getItem(key);
    return item ? item : defaultValue;
 };
 export const setLocalStorageItem = (key, value) => {
    localStorage.setItem(key, value);
 };